module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAmCAYAAAAxxTAbAAAACXBIWXMAAAsSAAALEgHS3X78AAABUUlEQVRIx7WWUXHDQAxE10VwEAzBEAzBEAwhEAwhEAwhEAzBEA5CGKg/99F2rNXKuXrGk4/sZec20pMGMwN7BmAFMDpf7wbUAZgALI6mwszcF2aFCN4wK013EN0amWxEsDXNSDS1aegt3uQHxqbbieYRmTzI4V24xc84XZMq3CKM0zUJ/qwjEyczOcnhWY3TNYHZTA6fmTiZCa15NU7XRKl5NU5motT8nLnFL5NEzYdxMhMFIZMS56VJJ4SskUk3hDATBSFPBSGXJkHNv8Q4S2RSBYRsKkKu3i8AhUzfs32ORHMgfISsgwas0U16NeESjHGt/mG2ZHHy12QSwVgzYLzCyqeI3xUTia6ZYeWh/l96JrNA3O7+u6tQimPZ1fQWke+spyU7W7ySe/ackp5J13nPUKCgRu0tu3ObmuwtCrZPUfNSTLrsxQgHDl9JJ6W3vgGYRTuZDgz2aQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lArrow.png
// module id = nEs8
// module chunks = 1